<template>
  <v-form lazy-validation @submit.prevent="next">
    <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
    </v-layout>
    <v-layout wrap row justify-center>
      <h3>&nbsp;</h3>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm6 lg6>
        <v-textarea
          :label="$t('surveys.create_survey.survey_name')"
          v-model="poll.title.$model"
          rows="1"
          auto-grow
          clearable
          counter
          maxlength="220"
          :error-messages="titleErrors"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm6 lg6>
        <v-select
          :items="periodicities.map((e) => ({ ...e, name: $t(e.langKey) }))"
          item-text="name"
          item-value="value"
          v-model="poll.periodicity.$model"
          :label="$t('surveys.create_survey.select_periodicity')"
          required
          :error-messages="periodicityErrors"
          :disabled="isEdit"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm6 lg6>
        <p>
          Los dias de la semana disponibles son:
          {{ ableDays.map((e) => e.nombre.replace('.', '')).join(', ') }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm6 lg6>
        <!-- <DateTimePicker
          :errorMessages="startDateErrors"
          titleDate="Fecha inicial"
          titleTime="Hora incial"
          v-model="poll.startDate.$model"
          :min="today"
          :hour="hour"
        /> -->
        <VueTimePickerTool
          :errorMessages="startDateErrors"
          :titleDate="$t('surveys.create_survey.start_date')"
          titleTime="Hora inicial"
          v-model="poll.startDate.$model"
          class="pickPoll"
          style="font-size: 1.1em; margin-top: 3px; margin-left: -5px"
          :min="today"
          location="up"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm6 lg6>
        <!-- <DateTimePicker
          titleDate="Fecha de término"
          titleTime="Hora de término"
          v-model="poll.endDate.$model"
          :min="today"
          v-show="poll.periodicity.$model !== 'SINGLE' && poll.periodicity.$model  !== ''"
        />-->
        <VueTimePickerTool
          :errorMessages="endDateErrors"
          :titleDate="$t('surveys.create_survey.end_date')"
          titleTime="Hora de término"
          v-model="poll.endDate.$model"
          v-show="
            poll.periodicity.$model !== 'SINGLE' &&
            poll.periodicity.$model !== ''
          "
          class="pickPoll"
          style="font-size: 1.1em; margin-top: 3px; margin-left: -5px"
          :min="today"
          location="up"
        />
      </v-flex>
    </v-layout>
    <ConfirmAccept
      @toggle="ontoggle"
      :value="showAlertInvalidDate"
      title="Aviso"
      description="El día que seleccionaste para programar tu encuesta, es un día inhábil para el colegio, por favor elige un día hábil"
    >
    </ConfirmAccept>
  </v-form>
</template>

<script>
// import DateTimePicker from "../Notices/Tools/DateTimePicker2";
import { mapGetters } from 'vuex'
import ConfirmAccept from '../../Dialogs/ConfirmAccept.vue'
import VueTimePickerTool from '../Notices/Tools/VueDateTimePicker'

export default {
  props: ['poll', 'isEdit'],
  components: {
    // DateTimePicker,
    VueTimePickerTool,
    ConfirmAccept,
  },
  data: () => ({
    showAlertInvalidDate: false,
    isInvalidTimeOut: false,
    isInvalidTimeIn: false,
    isInvalidDay: true,
    ableDays: [],
    concepts: [],
    today: '',
    hour: '',
    periodicities: [
      {
        name: 'SOLO UNA VEZ',
        value: 'SINGLE',
        langKey: 'surveys.create_survey.only_once',
      },
      {
        name: 'DIARIO',
        value: 'DAILY',
        langKey: 'surveys.create_survey.daily',
      },
      {
        name: 'SEMANAL',
        value: 'WEEKLY',
        langKey: 'surveys.create_survey.weekly',
      },
      {
        name: 'MENSUAL',
        value: 'MONTHLY',
        langKey: 'surveys.create_survey.monthly',
      },
    ],
  }),
  mounted() {
    this.today = new Date().toLocaleDateString('sv-SE')
    this.hour = new Date().toLocaleTimeString('sv-SE', {
      hour: '2-digit',
      minute: '2-digit',
    })
    this._setAbleDays()
  },
  methods: {
    _setAbleDays() {
      if (this.getBranch.ableDays === undefined) return
      this.ableDays = this.getBranch.ableDays
        .map((e) => e)
        .sort((a, b) => a.id > b.id)
    },
    _isAbleDay(day = '', posibleDays = []) {
      return posibleDays.some((e) => e.name === day)
    },
    _getDay(text = new Object()) {
      if (text === null) return
      return text.toString().split(' ')[0]
    },
    ontoggle(e) {
      this.showAlertInvalidDate = e
    },
    _handlerEmpty() {
      this.showAlertInvalidDate = false
      this.isInvalidDay = true
      this.$emit('isInvalidDay', true)
    },
    _handlerSingleDay() {
      let parsedTimeIn = this.poll.startDate.$model

      if (typeof parsedTimeIn !== 'string') {
        parsedTimeIn = new Date(parsedTimeIn).toString()
      }

      this.isInvalidTimeIn =
        parsedTimeIn === ''
          ? null
          : this._isAbleDay(this._getDay(parsedTimeIn), this.ableDays) === false
      this.showAlertInvalidDate = this.isInvalidTimeIn === true
      this.isInvalidDay =
        this.isInvalidTimeIn === true || this.isInvalidTimeIn === null
    },
    _handlerMultipleDays() {
      let parsedTimeIn = this.poll.startDate.$model
      let parsedTimeOut = this.poll.endDate.$model

      if (typeof parsedTimeIn !== 'string') {
        parsedTimeIn = new Date(parsedTimeIn).toString()
      }
      if (typeof parsedTimeOut !== 'string') {
        parsedTimeOut = new Date(parsedTimeOut).toString()
      }

      this.isInvalidTimeIn =
        parsedTimeIn === ''
          ? null
          : this._isAbleDay(this._getDay(parsedTimeIn), this.ableDays) === false
      this.isInvalidTimeOut =
        parsedTimeOut === ''
          ? null
          : this._isAbleDay(this._getDay(parsedTimeOut), this.ableDays) ===
            false
      this.showAlertInvalidDate =
        this.isInvalidTimeIn === true || this.isInvalidTimeOut === true
      this.isInvalidDay =
        this.isInvalidTimeIn === true ||
        this.isInvalidTimeIn === null ||
        this.isInvalidTimeOut === true ||
        this.isInvalidTimeOut === null
    },
  },
  computed: {
    titleErrors() {
      if (this.poll.title.$dirty && !this.poll.title.$model) {
        return ['Nombre requerido']
      }
      return []
    },
    periodicityErrors() {
      if (this.poll.periodicity.$dirty && !this.poll.periodicity.$model) {
        return ['Periodicidad requerida']
      }
      return []
    },
    startDateErrors() {
      if (this.poll.startDate.$dirty && !this.poll.startDate.$model) {
        return ['Fecha inicial requerida']
      }
      return []
    },
    endDateErrors() {
      if (this.poll.endDate.$dirty && !this.poll.endDate.$model) {
        return ['Fecha límite requerida']
      }
      return []
    },
    ...mapGetters(['getBranch']),
  },
  watch: {
    'poll.startDate.$model': function () {
      if (this.poll.periodicity.$model === '') {
        this._handlerEmpty()
        return
      }

      if (this.poll.periodicity.$model === 'SINGLE') {
        this._handlerSingleDay()
      }

      if (
        this.poll.periodicity.$model === 'DAILY' ||
        this.poll.periodicity.$model === 'WEEKLY' ||
        this.poll.periodicity.$model === 'MONTHLY'
      ) {
        this._handlerMultipleDays()
      }

      this.$emit('isInvalidDay', this.isInvalidDay)
    },
    'poll.endDate.$model': function () {
      if (this.poll.periodicity.$model === '') {
        this._handlerEmpty()
        return
      }

      // if (this.poll.periodicity.$model === 'SINGLE') {
      //   this._handlerSingleDay()
      // }

      if (
        this.poll.periodicity.$model === 'DAILY' ||
        this.poll.periodicity.$model === 'WEEKLY' ||
        this.poll.periodicity.$model === 'MONTHLY'
      ) {
        this._handlerMultipleDays()
      }

      this.$emit('isInvalidDay', this.isInvalidDay)
    },
    'poll.periodicity.$model': function () {
      if (this.poll.periodicity.$model === '') {
        this._handlerEmpty()
        return
      }

      if (this.poll.periodicity.$model === 'SINGLE') {
        this._handlerSingleDay()
      }

      if (
        this.poll.periodicity.$model === 'DAILY' ||
        this.poll.periodicity.$model === 'WEEKLY' ||
        this.poll.periodicity.$model === 'MONTHLY'
      ) {
        this._handlerMultipleDays()
      }

      this.$emit('isInvalidDay', this.isInvalidDay)
    },
    getBranch: function () {
      this._setAbleDays()
    },
  },
}
</script>

<style>
.pickPoll .vue__time-picker input.display-time {
  /* border: 1px solid #d2d2d2;
	width: 10em;
	padding: .3em .5em;
	font-size: 1em; */
  height: 40px;
}
</style>
